export const userTokenSelector = state => state.appState.userState.userToken;
export const cloudslicerTokenSelector = state => state.appState.userState.cloudslicerToken;
export const userEmailSelector = state => state.appState.userState.email;
export const availableArtifactsSelector = state => state.appState.userState.artifacts;
export const selectedArtifactSelector = state => state.appState.userState.selectedArtifact;
export const aboutSelector = state => state.appState.userState.about;
